import React, { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";

// Aparece con un fade-up suave cuando entra en pantalla
const Reveal = ({ children, delay = 0, sx, ...props }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node || !("IntersectionObserver" in window)) {
      setVisible(true);
      return;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      // El margen superior enorme cuenta como visible lo que ya quedó arriba,
      // así no queda nada oculto si se salta de golpe más allá de una sección
      { threshold: 0.15, rootMargin: "100000px 0px -40px 0px" }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <Box
      ref={ref}
      sx={{
        opacity: visible ? 1 : 0,
        transform: visible ? "none" : "translateY(32px)",
        transition: `opacity .8s ease ${delay}ms, transform .8s cubic-bezier(.2,.7,.2,1) ${delay}ms`,
        "@media (prefers-reduced-motion: reduce)": {
          opacity: 1,
          transform: "none",
          transition: "none",
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export default Reveal;
